import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { postSetNotificationsToRead } from "../actions/notificationActions";

export default function useIntrusiveNotifications() {
  const notifications = useSelector((state) => state.notificationsReducer);
  const dispatch = useDispatch();
  const [showIntrusiveModal, setShowIntrusiveModal] = useState(false);
  const [intrusiveNotifications, setIntrusiveNotifications] = useState([]);

  useEffect(() => {
    if (
      notifications.loading ||
      !notifications.notifications ||
      notifications.notifications.length === 0
    )
      return;

    const shownIdsRaw = localStorage.getItem(
      "intrusive_notifications_shown_ids",
    );
    const shownIds = shownIdsRaw ? JSON.parse(shownIdsRaw) : [];

    const unreadIntrusive = notifications.notifications.filter(
      (noti) =>
        noti.notice.isIntrusive &&
        !noti.isSeenByMe &&
        !noti.notice.isDeleted &&
        !shownIds.includes(noti.notice.id),
    );

    if (unreadIntrusive.length > 0) {
      setIntrusiveNotifications(unreadIntrusive);
      setShowIntrusiveModal(true);

      const newShownIds = [
        ...shownIds,
        ...unreadIntrusive.map((noti) => noti.notice.id),
      ];

      localStorage.setItem(
        "intrusive_notifications_shown_ids",
        JSON.stringify(newShownIds),
      );

      const idsToMarkAsRead = unreadIntrusive.map((noti) => noti.notice.id);
      dispatch(postSetNotificationsToRead(idsToMarkAsRead));
    }
  }, [notifications.loading, notifications.notifications, dispatch]);

  const handleCloseIntrusiveModal = () => {
    setShowIntrusiveModal(false);
  };

  const handleDismissIntrusiveModal = () => {
    setShowIntrusiveModal(false);
  };

  return {
    showIntrusiveModal,
    intrusiveNotifications,
    handleCloseIntrusiveModal,
    handleDismissIntrusiveModal,
  };
}
